var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoNotifications({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 812.158,
    height: 800,
    viewBox: "0 0 812.158 800",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-685.027 -293.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M549.973,747.783c13.013-11,20.917-28.366,18.844-45.275s-14.912-32.455-31.565-36.046-35.638,6.349-40.7,22.617c-2.784-31.364-5.992-64.043-22.667-90.752-15.1-24.185-41.251-41.49-69.593-44.586s-58.184,8.6-75.86,30.967-22,54.892-9.624,80.576c9.12,18.92,25.922,33,43.526,44.455a280.917,280.917,0,0,0,192.129,42.032",
    transform: "translate(412.538 338.163)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.621,560.459a529.9,529.9,0,0,1,73.846,73.329,531.44,531.44,0,0,1,83.175,138.993c1.5,3.67-4.462,5.268-5.943,1.638a525.985,525.985,0,0,0-48.06-90.932A527.982,527.982,0,0,0,341.263,564.817C338.186,562.311,342.569,557.974,345.621,560.459Z",
    transform: "translate(369.433 311.392)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.389,720.258c-11.172-9.44-17.957-24.352-16.178-38.869s12.8-27.863,27.1-30.946,30.6,5.451,34.938,19.417c2.39-26.927,5.144-54.981,19.459-77.912,12.963-20.763,35.414-35.62,59.746-38.277s49.951,7.38,65.126,26.586,18.891,47.126,8.262,69.175c-7.829,16.243-22.254,28.331-37.367,38.165a241.168,241.168,0,0,1-164.944,36.084",
    transform: "translate(452.479 366.654)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.281,560.269A397.939,397.939,0,0,0,528.356,718.375c-1.115,2.733,3.323,3.923,4.425,1.22A393.511,393.511,0,0,1,648.526,563.514C650.817,561.649,647.553,558.419,645.281,560.269Z",
    transform: "translate(463.717 367.993)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.253,
    cy: 50.253,
    r: 50.253,
    transform: "translate(942.778 552.622)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.255,287.388H817.486V306.33H515.454A135.227,135.227,0,0,0,380.227,441.558V656.769H342.341a6.314,6.314,0,0,1-6.314-6.314V422.615A135.227,135.227,0,0,1,471.255,287.388Z",
    transform: "translate(366.832 142.256)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.527,802.49V514.75h84.3V802.49a7.3,7.3,0,0,1-7.295,7.295H467.822A7.3,7.3,0,0,1,460.527,802.49Z",
    transform: "translate(444.156 283.465)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.027,654.718V420.741A140.65,140.65,0,0,1,465.518,280.25H822.7V662.823H333.132a8.115,8.115,0,0,1-8.105-8.105ZM819.455,283.492H465.518A137.4,137.4,0,0,0,328.269,420.741V654.718a4.868,4.868,0,0,0,4.863,4.863H819.455Z",
    transform: "translate(360 137.823)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.65,538.812a29.212,29.212,0,0,1-29.179-29.179V300.514a4.868,4.868,0,0,0-4.863-4.863H427.132a8.115,8.115,0,0,1-8.105-8.105v-76.19a8.115,8.115,0,0,1,8.105-8.105H595.724a8.115,8.115,0,0,1,8.105,8.105V509.633A29.212,29.212,0,0,1,574.65,538.812Z",
    transform: "translate(418.381 90)",
    fill: "#002bfe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.428,278.25h0a92.208,92.208,0,0,1,92.4,92.014V636.623H949.39a27.5,27.5,0,0,1,27.558,27.443H583.027v-293.8A92.208,92.208,0,0,1,675.428,278.25Z",
    transform: "translate(520.237 136.581)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.348,
    cy: 11.348,
    r: 11.348,
    transform: "translate(981.684 588.285)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoNotifications);
export default __webpack_public_path__ + "static/media/no-notifications.d9c86d6e6f71c3795308c93dc44e1cbf.svg";
export { ForwardRef as ReactComponent };